import {Pipe, PipeTransform} from '@angular/core';
import {DataBatchTools} from '@selpia/shared/utils';
import {DataPoint, DataPointParams} from '@selpia/shared/models';

@Pipe({standalone: true, name: 'getDataPoint'})
export class GetDataPointPipe implements PipeTransform {
  transform(
    value: DataPoint[],
    params: DataPointParams,
  ): DataPoint | undefined {
    const {measureCode, periodCode, date} = params;
    if (!measureCode || !periodCode || !date) {
      return;
    }

    return DataBatchTools.getDataPointFor(value, {measureCode, periodCode, date});
  }
}
